import { LetterheadCount, LetterheadPaper } from '~/tenants/bre/performable/print/letterheads/BreLetterheadsConfig';

type CountMap = Record<LetterheadCount, string>;

type PaperMap = Record<LetterheadPaper, Partial<CountMap>>;

export const BreLetterheadsRate: PaperMap = {
  smooth_white: {
    250: '290',
    500: '225',
    1000: '345',
  },
};

export const BreLetterheadsPay: PaperMap = {
  smooth_white: {
    250: '250',
    500: '270',
    1000: '300',
  },
};
